import React from "react";
import { getInstantValidationState } from '../../../utils/realTimeValidationUtils';

import './StandardLatePostOp.scss';

const StandardLatePostOp = ({ handleFormData, values, fieldErrors = {}, touchedFields = {} }) => {
  return (
    <div className="modern-assessment">
      <h2 className="assessment-title">Standaard Laat Post-operatief Formulier</h2>
      {(() => {
        const validation = getInstantValidationState('slpostop.slpostopQuestion1', fieldErrors, touchedFields, values.slpostop.slpostopQuestion1);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              1. Hoe goed voldeed de operatie/behandeling aan uw verwachtingen met betrekking tot afname van de pijn?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="slpostopQuestion1"
              required
              value={values.slpostop.slpostopQuestion1}
              onChange={(event) => handleFormData("slpostop", "slpostopQuestion1", event.target.value)}
              aria-label="Verwachtingen pijnafname"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Voldeed niet aan verwachtingen">Voldeed niet aan verwachtingen</option>
              <option value="Voldeed aan verwachtingen">Voldeed aan verwachtingen</option>
              <option value="Overtrof verwachtingen">Overtrof verwachtingen</option>
            </select>
            
          </div>
        );
      })()}    

      {(() => {
        const validation = getInstantValidationState('slpostop.slpostopQuestion2', fieldErrors, touchedFields, values.slpostop.slpostopQuestion2);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              2. Hoe goed voldeed de operatie/behandeling aan uw verwachtingen met betrekking tot verbetering van beweging en kracht van het aangedane gewricht?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="slpostopQuestion2"
              required
              value={values.slpostop.slpostopQuestion2}
              onChange={(event) => handleFormData("slpostop", "slpostopQuestion2", event.target.value)}
              aria-label="Verwachtingen beweging en kracht"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Voldeed niet aan verwachtingen">Voldeed niet aan verwachtingen</option>
              <option value="Voldeed aan verwachtingen">Voldeed aan verwachtingen</option>
              <option value="Overtrof verwachtingen">Overtrof verwachtingen</option>
            </select>
            
          </div>
        );
      })()}

      {(() => {
        const validation = getInstantValidationState('slpostop.slpostopQuestion3', fieldErrors, touchedFields, values.slpostop.slpostopQuestion3);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              3. Hoe goed voldeed de operatie/behandeling aan uw verwachtingen met betrekking tot het opnieuw oppakken van uw normale functioneren in het dagelijks leven?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="slpostopQuestion3"
              required
              value={values.slpostop.slpostopQuestion3}
              onChange={(event) => handleFormData("slpostop", "slpostopQuestion3", event.target.value)}
              aria-label="Verwachtingen dagelijks functioneren"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Voldeed niet aan verwachtingen">Voldeed niet aan verwachtingen</option>
              <option value="Voldeed aan verwachtingen">Voldeed aan verwachtingen</option>
              <option value="Overtrof verwachtingen">Overtrof verwachtingen</option>
            </select>
            
          </div>
        );
      })()}
      
      {(() => {
        const validation = getInstantValidationState('slpostop.slpostopQuestion4', fieldErrors, touchedFields, values.slpostop.slpostopQuestion4);
        return (
          <div className={validation.formGroupClasses}>
            <label className="modern-form-label required">
              4. Hoe goed voldeed de operatie/behandeling aan uw verwachtingen met betrekking tot het oppakken van normale sportieve activiteiten?
            </label>
            <select
              className={validation.inputClasses('modern-form-select')}
              name="slpostopQuestion4"
              required
              value={values.slpostop.slpostopQuestion4}
              onChange={(event) => handleFormData("slpostop", "slpostopQuestion4", event.target.value)}
              aria-label="Verwachtingen sportieve activiteiten"
              {...validation.ariaProps}
            >
              <option value="" hidden>Maak een keuze</option>
              <option value="Voldeed niet aan verwachtingen">Voldeed niet aan verwachtingen</option>
              <option value="Voldeed aan verwachtingen">Voldeed aan verwachtingen</option>
              <option value="Overtrof verwachtingen">Overtrof verwachtingen</option>
              <option value="Niet van toepassing - Ik doe niet aan sport">Niet van toepassing - Ik doe niet aan sport</option>
            </select>
            
          </div>
        );
      })()}
    </div>
  );
}

export default StandardLatePostOp;
